import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { ConstantService } from 'src/app/services/constant/constant.service';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { DataTable } from '@pascalhonegger/ng-datatable';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { NbDialogService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { MaskTextPipe } from 'src/app/shared/pipe/NameEmailHide.pipe';

@Component({
  selector: 'app-anonymous-users',
  templateUrl: './anonymous-users.component.html',
  styleUrls: ['./anonymous-users.component.scss'],
  providers: [MaskTextPipe],

})
export class AnonymousUsersComponent implements OnInit {
  @ViewChild('dataTable') dataTable: DataTable;
  responsive: any;
  pdfTable_body = [];
  searchText;
  loadingSpinner = false;
  enterprise: any;
  employeesAnonymous: any = [];
  currentSortColumn: string;
  currentSortOrder = 'asc';
  noDataSearch = false;
  excel: any = [];
  tableDataExcel: any = [];
  itemsPerPage = '5';
  getFiltersForm: UntypedFormGroup;
  searchTextUsername: any;
  searchTextEmail: any;
  anonymousFilters = [];
  noDataFound = true;
  excelArray: {};

  constructor(
    private readonly constantService: ConstantService,
    private readonly enterpriseService: EnterpriseService,
    private readonly storageService: CustomStorageService,
    private readonly dialogService: NbDialogService,
    private formBuilder: UntypedFormBuilder,
    private readonly translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeFilters();
    this.loadData();
  }

  initializeFilters() {
    this.getFiltersForm = this.formBuilder.group({
      searchTextEmail: this.searchTextEmail,
      searchTextUsername: this.searchTextUsername,
    });
  }

  /**
   * function is called to get list users anonyms from enterprise.
   */
  loadData() {
    this.searchTextEmail = this.getFiltersForm.controls.searchTextEmail.setValue('');
    this.searchTextUsername = this.getFiltersForm.controls.searchTextUsername.setValue('');
    this.loadingSpinner = true;
    this.enterprise = this.storageService.getEnterprise();
    this.enterpriseService.getAnonymousUsers().subscribe((data: any) => {
      if (data.users.length > 0) {
        this.employeesAnonymous = data.users.map(x => ({
          _id: x.id,
          email: x.email,
          username: x.username,
          firstName: x.firstName,
          lastName: x.lastName,
          gender: x.gender,
          phoneNumber: x.phoneNumber,
          birthdate: x.birthdate,
          type: x.type
        }));
        this.anonymousFilters = this.employeesAnonymous;
        // data download for file excel
        this.saveDataExcel();
        this.noDataFound = false;
      }
      this.loadingSpinner = false;
    },
      error => {
        this.loadingSpinner = false;
      });
  }

  /**
   * Save the data in the excel array
   */
  saveDataExcel() {
    this.tableDataExcel = this.employeesAnonymous
      .map((x) => ({
        Email: x.email,
        Name: x.fullName
      }));
    this.excel = this.constantService.translateKeys(this.tableDataExcel);
  }

  paginateChange(event) {
    this.dataTable.setPage(1, this.dataTable.rowsOnPage);
  }

  /**
   * function is called to show modal for download list anonymous users .
   */
  openDialogDownload(dialog: TemplateRef<any>, data: any = null, index: number = null) {
    const context = {
      index,
    };
    this.dialogService.open(dialog, { context });
  }

  /**
   * function is called to show modal for download list anonymous users excel .
   */
  exportAsXLSX(): void {
    this.constantService.exportAsXLSX(this.excel, 'pages_titles.users_anonyms.list');
  }

  /**
   * Multi search function on session table
   */
  onFilterChange() {
    this.searchTextEmail = this.getFiltersForm.controls.searchTextEmail.value;
    this.searchTextUsername = this.getFiltersForm.controls.searchTextUsername.value;

    this.employeesAnonymous = this.anonymousFilters.filter(employee => {
      let isPassed = true;
      if (this.searchTextEmail && this.searchTextEmail !== '') {
        const maskedEmail = employee.email.substring(0, 3) + '*'.repeat(employee.email.length - 3);
        employee.email = employee.email.toString().trim().toLowerCase();
        this.searchTextEmail = this.searchTextEmail.trim().toLowerCase();
        isPassed = isPassed && maskedEmail.indexOf(this.searchTextEmail) > -1;
      }

      if (this.searchTextUsername && this.searchTextUsername !== '') {
        const user = employee.username.substring(0, 3) + '*'.repeat(employee.username.length - 3);
        employee.username = employee.username.toString().trim().toLowerCase();
        this.searchTextUsername = this.searchTextUsername.trim().toLowerCase();
        isPassed = isPassed && user.indexOf(this.searchTextUsername) > -1;
      }

      return isPassed;
    });
    this.saveDataExcel();
    this.employeesAnonymous.length > 0 ? this.noDataSearch = false : this.noDataSearch = true;
  }

}
